let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jwuG0")).then(() => parcelRequire('keiA6'));